import Axios from '../axios-instance';

const GeneralAPI = {
    getVersion: () => {
        return Axios.get(`/General/Version`).then(({ data }) => data);
    }
};

export default GeneralAPI;
